import React from "react";
const SocialsIg = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z"
        stroke="url(#paint0_linear_11:458)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V7C22 4.23858 19.7614 2 17 2Z"
        stroke="url(#paint1_radial_11:458)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 11.3698C16.1234 12.2021 15.9812 13.052 15.5937 13.7988C15.2062 14.5456 14.5931 15.1512 13.8416 15.5295C13.0901 15.9077 12.2384 16.0394 11.4077 15.9057C10.5771 15.7721 9.80971 15.3799 9.21479 14.785C8.61987 14.1901 8.22768 13.4227 8.09402 12.592C7.96035 11.7614 8.09202 10.9097 8.47028 10.1582C8.84854 9.40667 9.45414 8.79355 10.2009 8.40605C10.9477 8.01856 11.7977 7.8764 12.63 7.99981C13.4789 8.1257 14.2648 8.52128 14.8716 9.12812C15.4785 9.73496 15.8741 10.5209 16 11.3698Z"
        stroke="url(#paint2_linear_11:458)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 11.3698C16.1234 12.2021 15.9812 13.052 15.5937 13.7988C15.2062 14.5456 14.5931 15.1512 13.8416 15.5295C13.0901 15.9077 12.2384 16.0394 11.4077 15.9057C10.5771 15.7721 9.80971 15.3799 9.21479 14.785C8.61987 14.1901 8.22768 13.4227 8.09402 12.592C7.96035 11.7614 8.09202 10.9097 8.47028 10.1582C8.84854 9.40667 9.45414 8.79355 10.2009 8.40605C10.9477 8.01856 11.7977 7.8764 12.63 7.99981C13.4789 8.1257 14.2648 8.52128 14.8716 9.12812C15.4785 9.73496 15.8741 10.5209 16 11.3698Z"
        stroke="url(#paint3_linear_11:458)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 6.5H17.51"
        stroke="#CE2E95"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11:458"
          x1="4.625"
          y1="2"
          x2="21.125"
          y2="22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4769D7" />
          <stop offset="0.619792" stopColor="#CE2E95" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_11:458"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.375 21.375) rotate(-69.444) scale(16.02)"
        >
          <stop stopColor="#FED77A" />
          <stop offset="0.649108" stopColor="#EC524A" />
          <stop offset="1" stopColor="#EC524A" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_11:458"
          x1="8.75"
          y1="6.875"
          x2="14.75"
          y2="15.9565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4769D7" />
          <stop offset="0.619792" stopColor="#CE2E95" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_11:458"
          x1="8.04321"
          y1="18.625"
          x2="12.0432"
          y2="12.875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F77630" />
          <stop offset="1" stopColor="#D43871" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SocialsIg;
